import wx from 'weixin-js-sdk'
import Vue from 'vue'
import { getSignature } from '@/api/api'

// 微信网页开发权限验证配置
export function wxGetSignature() {
  return new Promise( async (resolve, reject) => {
    let signLink = location.href.split('#')[0]
    const para = {
      // url: encodeURIComponent(signLink)
      url: signLink
    }
    const { nonceStr, timestamp, signature} = await getSignature(para)

    wx.config({
      debug: false,
      appId: Vue.prototype.$app_id,
      timestamp: timestamp,
      nonceStr: nonceStr,
      signature: signature,
      jsApiList: [
        'scanQRCode'
      ]
    })
    wx.ready(() => {
      resolve()
    })
    wx.error((err) => {
      reject(err)
    })
  })
}